(function () {
  'use strict';

  function parseJsonElement(element) {
    if (!element) return null;
    try {
      var value = JSON.parse(element.textContent || 'null');
      return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (error) {
      console.warn('ShadowsDeal JSON data could not be parsed.', error);
      return null;
    }
  }

  function parseProduct(section) {
    var sectionId = section.getAttribute('data-section-id');
    return parseJsonElement(document.getElementById('ProductJson-' + sectionId));
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function optionSelectors(section) {
    return Array.prototype.slice.call(section.querySelectorAll('.single-option-selector'));
  }

  function findVariantFromOptions(section, product) {
    if (!product || !Array.isArray(product.variants)) return null;
    var values = optionSelectors(section).map(function (selector) { return selector.value; });
    if (!values.length) return null;

    return product.variants.find(function (variant) {
      var options = variant.options || [];
      return values.every(function (value, index) { return String(options[index]) === String(value); });
    }) || null;
  }

  function selectedVariant(section, product) {
    var optionVariant = findVariantFromOptions(section, product);
    if (optionVariant) return optionVariant;

    var select = section.querySelector('[id^="ProductSelect-"]');
    if (!select || !product || !Array.isArray(product.variants)) return null;
    var id = String(select.value);
    return product.variants.find(function (variant) {
      return String(variant.id) === id;
    }) || null;
  }

  function setText(node, value) {
    if (node) node.textContent = value;
  }

  function updateVariantMeta(section, product, explicitVariant) {
    var variant = explicitVariant || selectedVariant(section, product);
    if (!variant) return;

    var masterSelect = section.querySelector('[id^="ProductSelect-"]');
    if (masterSelect && String(masterSelect.value) !== String(variant.id)) {
      masterSelect.value = String(variant.id);
    }

    var stock = section.querySelector('[data-sdp-stock]');
    if (stock) {
      stock.classList.toggle('is-sold-out', !variant.available);
      stock.innerHTML = '<span class="sdp-stock__dot" aria-hidden="true"></span>' + (variant.available ? 'In stock' : 'Sold out');
    }

    var skuWrap = section.querySelector('[data-sdp-sku]');
    var skuValue = section.querySelector('[data-sdp-sku-value]');
    if (skuWrap && skuValue) {
      skuValue.textContent = variant.sku || '';
      skuWrap.classList.toggle('is-hidden', !variant.sku);
    }

    var price = section.querySelector('[id^="ProductPrice-"]');
    var compare = section.querySelector('[id^="ComparePrice-"]');
    setText(price, money(variant.price));
    if (compare) {
      var hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      compare.textContent = hasCompare ? money(variant.compare_at_price) : '';
      compare.classList.toggle('hide', !hasCompare);
      compare.classList.toggle('is-hidden', !hasCompare);
    }

    var saving = section.querySelector('[data-sdp-saving]');
    if (saving) {
      var amount = Number(variant.compare_at_price || 0) - Number(variant.price || 0);
      saving.textContent = amount > 0 ? 'Save ' + money(amount) : '';
      saving.classList.toggle('is-hidden', amount <= 0);
    }

    var addButton = section.querySelector('[id^="AddToCart-"]');
    var addText = section.querySelector('[id^="AddToCartText-"]');
    if (addButton && addText) {
      addButton.disabled = !variant.available;
      var strings = (window.theme && window.theme.productStrings) || {};
      addText.textContent = variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
    }
  }

  function matchingVariants(product, optionIndex, value) {
    if (!product || !Array.isArray(product.variants)) return [];
    return product.variants.filter(function (variant) {
      return variant.options && String(variant.options[optionIndex]) === String(value);
    });
  }

  function splitOptionLabel(value) {
    var match = String(value).match(/^(.+?)\s*\((.+)\)\s*$/);
    return match ? { title: match[1], detail: match[2] } : { title: String(value), detail: '' };
  }

  function syncOptionCards(section) {
    optionSelectors(section).forEach(function (selector) {
      var cards = section.querySelector('[data-sdp-option-cards="' + selector.getAttribute('data-index') + '"]');
      if (!cards) return;
      cards.querySelectorAll('[data-sdp-option-value]').forEach(function (button) {
        var selected = String(button.getAttribute('data-sdp-option-value')) === String(selector.value);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
    });
  }

  function syncVariantFromOptions(section, product) {
    var variant = findVariantFromOptions(section, product);
    if (!variant) return null;

    var masterSelect = section.querySelector('[id^="ProductSelect-"]');
    if (masterSelect && String(masterSelect.value) !== String(variant.id)) {
      masterSelect.value = String(variant.id);
      masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncOptionCards(section);
    updateVariantMeta(section, product, variant);
    return variant;
  }

  function buildOptionCards(section, product) {
    var selectors = optionSelectors(section);
    selectors.forEach(function (selector, optionIndex) {
      if (selector.dataset.sdpCardsReady === 'true') return;
      selector.dataset.sdpCardsReady = 'true';

      var label = section.querySelector('label[for="' + selector.id + '"]');
      var group = document.createElement('div');
      group.className = 'sdp-option-cards';
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', label ? label.textContent.trim() : 'Choose an option');
      group.setAttribute('data-sdp-option-cards', selector.getAttribute('data-index') || ('option' + (optionIndex + 1)));

      Array.prototype.slice.call(selector.options).forEach(function (option) {
        var variants = matchingVariants(product, optionIndex, option.value);
        var available = variants.some(function (variant) { return variant.available; });
        var singleOptionVariant = selectors.length === 1 ? variants[0] : null;
        var labelParts = splitOptionLabel(option.textContent.trim());

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sdp-option-card';
        button.setAttribute('role', 'radio');
        button.setAttribute('data-sdp-option-value', option.value);
        button.setAttribute('aria-checked', option.selected ? 'true' : 'false');
        button.disabled = !available;
        button.classList.toggle('is-selected', option.selected);

        var title = document.createElement('strong');
        title.className = 'sdp-option-card__title';
        title.textContent = labelParts.title;
        button.appendChild(title);

        if (labelParts.detail) {
          var detail = document.createElement('span');
          detail.className = 'sdp-option-card__detail';
          detail.textContent = labelParts.detail;
          button.appendChild(detail);
        }

        if (singleOptionVariant) {
          var price = document.createElement('span');
          price.className = 'sdp-option-card__price';
          price.textContent = money(singleOptionVariant.price);
          if (Number(singleOptionVariant.compare_at_price || 0) > Number(singleOptionVariant.price || 0)) {
            var oldPrice = document.createElement('s');
            oldPrice.textContent = money(singleOptionVariant.compare_at_price);
            price.appendChild(oldPrice);
          }
          button.appendChild(price);
        }

        if (!available) {
          var sold = document.createElement('span');
          sold.className = 'sdp-option-card__sold';
          sold.textContent = 'Sold out';
          button.appendChild(sold);
        }

        button.addEventListener('click', function () {
          if (button.disabled) return;
          selector.value = option.value;
          selector.dispatchEvent(new Event('change', { bubbles: true }));
          syncVariantFromOptions(section, product);
        });

        group.appendChild(button);
      });

      selector.classList.add('sdp-select--enhanced');
      selector.insertAdjacentElement('afterend', group);
    });

    syncOptionCards(section);
  }

  function initQuantity(section) {
    var input = section.querySelector('[data-sdp-quantity-input]');
    if (!input || input.dataset.sdpQuantityReady === 'true') return;
    input.dataset.sdpQuantityReady = 'true';

    var wrap = input.closest('[data-sdp-quantity]');
    var minus = section.querySelector('[data-sdp-quantity-minus]');
    var plus = section.querySelector('[data-sdp-quantity-plus]');

    function limits() {
      return {
        min: Number.parseInt(input.min || '1', 10) || 1,
        max: input.max ? (Number.parseInt(input.max, 10) || Infinity) : Infinity,
        step: Number.parseInt(input.step || '1', 10) || 1
      };
    }

    function normalize(value) {
      var limit = limits();
      var parsed = Number.parseInt(value, 10);
      var next = Number.isFinite(parsed) ? parsed : limit.min;
      return Math.min(limit.max, Math.max(limit.min, next));
    }

    function animate() {
      if (!wrap) return;
      wrap.classList.remove('is-changing');
      void wrap.offsetWidth;
      wrap.classList.add('is-changing');
      window.setTimeout(function () { wrap.classList.remove('is-changing'); }, 220);
    }

    function updateControls() {
      var limit = limits();
      if (minus) minus.disabled = Number(input.value) <= limit.min;
      if (plus) plus.disabled = Number(input.value) >= limit.max;
    }

    function commit(value) {
      input.value = String(normalize(value));
      updateControls();
      input.dispatchEvent(new Event('change', { bubbles: true }));
      animate();
    }

    if (minus) minus.addEventListener('click', function () { commit(Number(input.value) - limits().step); });
    if (plus) plus.addEventListener('click', function () { commit(Number(input.value) + limits().step); });
    input.addEventListener('change', function () {
      input.value = String(normalize(input.value));
      updateControls();
    });
    input.addEventListener('blur', function () {
      input.value = String(normalize(input.value));
      updateControls();
    });
    input.value = String(normalize(input.value));
    updateControls();
  }

  function initThumbnails(section) {
    var mainImage = section.querySelector('.sdp-gallery__image');
    var stage = section.querySelector('.sdp-gallery__stage');
    if (!mainImage || !stage || stage.dataset.sdpThumbsReady === 'true') return;
    stage.dataset.sdpThumbsReady = 'true';

    section.querySelectorAll('[data-sdp-thumbnail]').forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function (event) {
        event.preventDefault();
        var thumbImage = thumbnail.querySelector('img');
        var target = thumbnail.getAttribute('href');
        if (!target) return;

        mainImage.src = target;
        mainImage.removeAttribute('srcset');
        if (thumbImage && thumbImage.alt) mainImage.alt = thumbImage.alt;

        var zoom = thumbnail.getAttribute('data-zoom');
        if (zoom) stage.setAttribute('data-zoom', zoom);

        section.querySelectorAll('[data-sdp-thumbnail]').forEach(function (item) { item.classList.remove('is-active'); });
        thumbnail.classList.add('is-active');
      });
    });
  }

  function starText(rating) {
    var rounded = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return '★★★★★'.slice(0, rounded) + '☆☆☆☆☆'.slice(rounded);
  }

  function formatDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
      year: 'numeric', month: 'short', day: 'numeric'
    }).format(date);
  }

  function buildReviewFallback(section, data) {
    var reviewSection = section.querySelector('.sdp-reviews');
    if (!reviewSection || !data || Number(data.number_of_reviews || 0) < 1) return null;
    if (reviewSection.querySelector('.sdp-review-fallback')) return reviewSection.querySelector('.sdp-review-fallback');

    var fallback = document.createElement('div');
    fallback.className = 'sdp-review-fallback';
    fallback.setAttribute('data-sdp-review-fallback', 'true');

    var summary = document.createElement('div');
    summary.className = 'sdp-review-fallback__summary';

    var score = document.createElement('div');
    score.className = 'sdp-review-fallback__score';
    var average = document.createElement('strong');
    average.textContent = Number(data.average_rating || 0).toFixed(2);
    var stars = document.createElement('span');
    stars.className = 'sdp-review-stars';
    stars.textContent = starText(data.average_rating);
    stars.setAttribute('aria-label', average.textContent + ' out of 5 stars');
    var count = document.createElement('span');
    count.textContent = 'Based on ' + Number(data.number_of_reviews || 0) + ' reviews';
    score.append(average, stars, count);
    summary.appendChild(score);

    if (Array.isArray(data.histogram)) {
      var histogram = document.createElement('div');
      histogram.className = 'sdp-review-histogram';
      data.histogram.forEach(function (row) {
        var line = document.createElement('div');
        line.className = 'sdp-review-histogram__row';
        var label = document.createElement('span');
        label.textContent = row.rating + '★';
        var track = document.createElement('span');
        track.className = 'sdp-review-histogram__track';
        var fill = document.createElement('span');
        fill.className = 'sdp-review-histogram__fill';
        fill.style.width = Math.max(0, Math.min(100, Number(row.percentage || 0))) + '%';
        track.appendChild(fill);
        var frequency = document.createElement('span');
        frequency.textContent = String(row.frequency || 0);
        line.append(label, track, frequency);
        histogram.appendChild(line);
      });
      summary.appendChild(histogram);
    }

    fallback.appendChild(summary);

    var reviews = Array.isArray(data.reviews) ? data.reviews.slice(0, 5) : [];
    if (reviews.length) {
      var list = document.createElement('div');
      list.className = 'sdp-review-fallback__list';
      reviews.forEach(function (review) {
        var card = document.createElement('article');
        card.className = 'sdp-review-card';

        var top = document.createElement('div');
        top.className = 'sdp-review-card__top';
        var cardStars = document.createElement('span');
        cardStars.className = 'sdp-review-stars';
        cardStars.textContent = starText(review.rating);
        cardStars.setAttribute('aria-label', review.rating + ' out of 5 stars');
        var date = document.createElement('time');
        date.textContent = formatDate(review.created_at);
        if (review.created_at) date.dateTime = review.created_at;
        top.append(cardStars, date);
        card.appendChild(top);

        if (review.title) {
          var title = document.createElement('h3');
          title.textContent = review.title;
          card.appendChild(title);
        }

        var body = document.createElement('p');
        body.textContent = review.body || '';
        card.appendChild(body);

        var byline = document.createElement('div');
        byline.className = 'sdp-review-card__byline';
        var reviewer = document.createElement('strong');
        reviewer.textContent = review.reviewer_name || 'Customer';
        byline.appendChild(reviewer);
        if (review.verified_buyer) {
          var verified = document.createElement('span');
          verified.className = 'sdp-review-verified';
          verified.textContent = '✓ Verified buyer';
          byline.appendChild(verified);
        }
        card.appendChild(byline);
        list.appendChild(card);
      });
      fallback.appendChild(list);
    }

    var note = document.createElement('p');
    note.className = 'sdp-review-fallback__note';
    note.textContent = reviews.length < Number(data.number_of_reviews || 0)
      ? 'Showing recent verified feedback while the complete review widget loads.'
      : 'Customer feedback supplied by the connected review service.';
    fallback.appendChild(note);

    reviewSection.appendChild(fallback);
    return fallback;
  }

  function initReviews(section) {
    var reviewSection = section.querySelector('.sdp-reviews');
    if (!reviewSection || reviewSection.dataset.sdpReviewsReady === 'true') return;
    reviewSection.dataset.sdpReviewsReady = 'true';

    var script = document.querySelector('script[id^="SdpJudgeMeReviewData-"]');
    var data = parseJsonElement(script);
    if (!data || Number(data.number_of_reviews || 0) < 1) return;

    var widget = reviewSection.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    var hasNativeReviews = function () {
      return !!(widget && widget.querySelector('.jdgm-rev, .jdgm-rev-widg__reviews .jdgm-rev'));
    };

    function reconcile() {
      var fallback = reviewSection.querySelector('.sdp-review-fallback');
      if (hasNativeReviews()) {
        if (fallback) fallback.remove();
      } else if (!fallback) {
        buildReviewFallback(section, data);
      }
    }

    if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') {
      try { window.jdgm.initializeWidgets(); } catch (error) { console.warn('Judge.me refresh was not available.', error); }
    }

    window.setTimeout(reconcile, 1200);
    window.setTimeout(reconcile, 3000);

    if (widget && window.MutationObserver) {
      var observer = new MutationObserver(reconcile);
      observer.observe(widget, { childList: true, subtree: true });
      window.setTimeout(function () { observer.disconnect(); }, 15000);
    }
  }

  function initProduct(section) {
    if (!section || section.dataset.sdpUpgradeReady === 'true') return;
    section.dataset.sdpUpgradeReady = 'true';

    var product = parseProduct(section);
    initQuantity(section);
    initThumbnails(section);
    buildOptionCards(section, product);
    initReviews(section);

    optionSelectors(section).forEach(function (selector) {
      selector.addEventListener('change', function () {
        syncVariantFromOptions(section, product);
      });
    });

    var variantSelect = section.querySelector('[id^="ProductSelect-"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        updateVariantMeta(section, product);
        syncOptionCards(section);
      });
    }

    syncVariantFromOptions(section, product);
    updateVariantMeta(section, product);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-sdp-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
